import { useContext } from 'react';
import MetricsInspectionContext from '../context';
import { last } from 'lodash';
import { onRestorePeriod, onSelectPeriod } from '../actions';

const usePeriods = () => {
  const {
    state: { periods = [] },
    dispatch
  } = useContext(MetricsInspectionContext);

  const lastPeriod = last(periods);

  const selectPeriod = period => dispatch(onSelectPeriod(period));
  const restorePeriod = () => dispatch(onRestorePeriod());

  return {
    periods,
    lastPeriod,
    selectPeriod,
    restorePeriod
  };
};

export default usePeriods;
